import { createAction } from "@reduxjs/toolkit";
import i18n from "i18n";
import { errorMsg } from "../reducers/snackMsgsReducers";

const appBaseUrl = process.env.REACT_APP_AMBACK;

const api = ({
	type = "api/call",
	customUrl = null,
	url = "",
	method = "GET",
	onLoading = null,
	data = null,
	onSuccess,
	onFailure = () => {},
	accessToken = null,
	headers = null,
	schema = null,
	withCredentials = false,
	trackLoading = false
}) => {
	if (!onSuccess) {
		if (type === "api/call") {
			onSuccess = () => {};
		} else {
			onSuccess = createAction(`${type}Success`);
		}
	}
	if (trackLoading) {
		onLoading = createAction(`${type}Loading`);
	}
	return {
		type,
		payload: {
			isCustomUrl: !!customUrl,
			requestUrl: customUrl ? customUrl : appBaseUrl + url,
			method,
			data,
			accessToken,
			onLoading,
			onSuccess,
			onFailure,
			headers,
			schema,
			withCredentials
		}
	};
};

const apiError = createAction("api/error", (error, label) => ({
	error: error && error.message ? error.message : error,
	payload: label
}));
const apiAccessDenied = createAction("api/access_denied");

export { api, apiError, apiAccessDenied };
